import { Component, Inject } from '@angular/core';
import { FeedbackService, ToastType } from '../feedback/feedback.service';
import { ScreenLayout, SCREEN_LAYOUT } from '../layout/layout.provider';

@Component({
    selector: 'app-feedback',
    template: `
    <ngb-toast *ngIf="feedbackService.feedback | async as feedbackConfig"
                class="position-absolute z-top top-50 start-50 translate-middle opacity-75 feedback"
                [class.bg-black]="feedbackConfig.type === FeedbackType.ERROR"
                [class.bg-success]="feedbackConfig.type === FeedbackType.SUCCESS"
                [autohide]="true"
                [delay]="3000"
                (hidden)="feedbackService.clear()">
      <div class="toast-wrapper d-flex flex-column justify-content-between align-items-center">
        <span class="material-icons text-white lh-1"
              [ngClass]="layout === 'desktop' ? 'md-128' : 'md-64'">{{feedbackConfig.icon}}
        </span>
        <p class="text-white fs-2 text-center">{{feedbackConfig.text}}</p>
      </div>
    </ngb-toast>
  `,
    styles: [`
    $toastSize: 240px;
    $toastMaxSize: 40vw;
    .z-top {
      z-index: 2500;
    }
    .feedback {
      width: $toastSize;
      height: $toastSize;
      max-width: $toastMaxSize;
      max-height: $toastMaxSize;
    }
    .toast-wrapper {
      width: calc($toastSize - 1.5rem);
      height: calc($toastSize - 1.5rem);
      max-width: calc($toastMaxSize - 1.5rem);
      max-height: calc($toastMaxSize - 1.5rem);
    }
  `],
    standalone: false
})

export class FeedbackComponent {
  FeedbackType = ToastType;

  constructor(@Inject(SCREEN_LAYOUT) public layout: ScreenLayout, public readonly feedbackService: FeedbackService){}
}
